import { CardGame } from './card-game'
import styles from './section-down.module.css'

type Props = {
  onRetry?: () => void
}

export function SectionDown({ onRetry = () => window.location.reload() }: Props) {
  return (
    <div className={styles.down} role="status">
      <h2 className={styles.title}>Раздел временно не работает</h2>
      <p className={styles.lead}>Пока мы его чиним, можете выбрать себе карту.</p>
      <CardGame count={5} maxWidth={92} maxScale={2} />
      <p className={styles.retry}>
        Уже починили?{' '}
        <button type="button" onClick={onRetry}>
          Повторить
        </button>
      </p>
    </div>
  )
}
